import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "src/hooks/useAuth";

export const Callback = () => {
  const { isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [isLoading, isAuthenticated, navigate]);

  return <div>Processing login...</div>;
};
